import React from "react";

const AIforExpertsSection =()=>{
    return(
        <>

      
      <section className=" bg-secondary position-relative py-5 mb-2 pb-2 pb-lg-5 mb-3">
       {/* <!-- Item --> */}
        <div className="container pt-5 pb-5">
        <div className="row row-cols-md-2 row-cols-1 gy-4 mb-5 mt-auto justify-content-center align-items-center ">
            <div className="col">
              <h2 className=" text-primary">AI That Amplifies Experts, Not Replaces Them</h2>
            </div>
            <div className="col">
            <div className="pe-md-4 me-md-2 ps-lg-5 ms-lg-5 ">
                    <p className="fs-lg text-white  mb-0">
                    Our AI systems reinforce every decision our auditors make.
                    </p>
                      <ul className="list-unstyled pb-2 pt-4">
                      <li className="d-flex align-items-center pb-1 mb-2">
                        <i className="bx bx-check-circle text-primary fs-xl me-2"></i>
                        Analyze inspection data, documentation, and historical trends
                      </li>
                      <li className="d-flex align-items-center pb-1 mb-2">
                        <i className="bx bx-check-circle text-primary fs-xl me-2"></i>
                        Instantly surface potential compliance and quality issues 
                      </li>
                      <li className="d-flex align-items-center pb-1 mb-2">
                        <i className="bx bx-check-circle text-primary fs-xl me-2"></i>
                        Automate detailed reviews, so auditors can focus on the critical issues
                      </li>
                    </ul>
                    <p className="fs-lg text-white  mb-0">
                    This human-AI collaboration delivers precision, traceability, and confidence—ensuring nothing is missed, and no rework surprises appear downstream.
                    </p>
                 

                    </div>
            </div>
          </div>
        </div>
      </section>

        </>
    )
}

export default AIforExpertsSection